import { ValidationType } from "../Enums/ValidationEnums";

// Return a validator function using the specified limits
export function InRangeFunction<TValue>(minValidValue?: TValue, maxValidValue?: TValue): (value: TValue) => boolean
{
    return function (value: TValue): boolean
    { 
        if (undefined != minValidValue)
            if (value < minValidValue)
                return false;
        if (undefined != maxValidValue)
            if (value > maxValidValue)
                return false;
        return true;
    }
}

export function LimitToNumberCharacters(char: string): boolean
{
    return InRangeFunction('0', '9')(char);
}

export function LimitToPhoneCharacters(char: string, rawvalue: string|undefined): boolean
{
  const validChar = ["0","1","2","3","4","5","6","7","8","9","-","(",")", " "].includes(char);
  if (!validChar)
      return false;

  // Limit to 10 digits
  if (10 == rawvalue?.match(/\d/gm)?.length)
      return false;

  return true;
}


export function LimitToFilenameCharacters(char: string): boolean
{
    const invalidCharacters = "#<$+%>!`&*'|{?\"=}/:\\@";
    return invalidCharacters.indexOf(char) > 0 ? false : true;
}


export function LimitToFloat(char: string, rawValue: string | undefined): boolean
{    
  if ("." === char) {  
      if ((rawValue == undefined) || (rawValue.indexOf(".") === -1))
        return true; 
    return false;
  }
  if ("-" === char)   { 
      if ((rawValue == undefined) || (rawValue.indexOf("-") === -1))
        return true; 
    return false;
  }
  return LimitToNumberCharacters(char);  
}

export function LimitToFloatPositive(char: string, rawValue: string | undefined): boolean
{    
  if ("." === char) {  
      if ((rawValue == undefined) || (rawValue.indexOf(".") === -1))
        return true; 
    return false;
  }
  if ("-" === char)   { 
    return false;
  }
  return LimitToNumberCharacters(char);  
}

export function LimitToInteger(char: string, rawValue: string | undefined): boolean
{    
  if ("." === char) {  
    return false;
  }
  if ("-" === char)   { 
      if ((rawValue == undefined) || (rawValue.indexOf("-") === -1))
        return true; 
    return false;
  }
  return LimitToNumberCharacters(char);  
}

export function LimitToIntegerPositive(char: string, rawValue: string | undefined): boolean
{    
  if ("." === char) {  
    return false;
  }
  if ("-" === char)   { 
    return false;
  }
  return LimitToNumberCharacters(char);  
}

// See if there are any special characters in a string
export function containsCharacter(stringToCheck: string | undefined, specialCharacterDomain: string): boolean
{
 // Check if at least one special character exists
 if (!stringToCheck)
  return false;

  for(let specialChar of specialCharacterDomain.split(""))
  {
    if (stringToCheck.indexOf(specialChar) > -1)
      return true;
  }
 return false;
}

// Look for 10 digits
export function isValidPhone(phoneNumber?: string): boolean
{
  if (undefined === phoneNumber)
    return false;
  return 10 == phoneNumber.match(/\d/gm)?.length;
}

export function isValidEmail(email?: string): boolean
{
  if (undefined === email)
    return false;
  return !!email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i);
}

export function isValidURL(str?: string) {
  if (!str) return false;
  const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

export function replaceInvalid(input: string, type: ValidationType): string 
{
  if (type == ValidationType.Subject)
    return input.replace(/[^a-zA-Z0-9 ,.;:!@#\-=+$%*(){}?\[\]'/]/g, '');
  return input;
}